import React from 'react';
import { useSingleEffect } from 'react-haiku';

import Alert from 'components/Misc/Alert';

const Devices = ({ tab, setTab }) => {
	// Update selected tab
	useSingleEffect(() => setTab(tab));
	
	return (
		<Alert
			theme="danger"
			icon="warning"
			message="Dotā sadaļa vēl tiek izstrādāta vai testēta!"
			className="mt-4"
		/>
	);
};

export default Devices;
